import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);
gsap.defaults({ duration: 0.8, ease: 'power3.out' });

// Animações só rodam para quem não pediu movimento reduzido.
export const MOTION_OK = '(prefers-reduced-motion: no-preference)';

// Revela elementos [data-reveal] do escopo quando entram na tela.
// Serve para ordenar a leitura (título, depois conteúdo), não para enfeite.
export const revealOnScroll = (selector = '[data-reveal]') => {
  gsap.set(selector, { autoAlpha: 0, y: 28 });
  ScrollTrigger.batch(selector, {
    start: 'top 88%',
    once: true,
    onEnter: (batch) => gsap.to(batch, { autoAlpha: 1, y: 0, stagger: 0.08, overwrite: true }),
  });
};

export { gsap, ScrollTrigger, useGSAP };
